import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";

export default function PaymentResult() {
  const loc = useLocation();
  const cancelled = loc.pathname.includes("cancel");
  const [status, setStatus] = useState(cancelled ? "cancel" : "checking");

  useEffect(() => {
    if (cancelled) return;
    const params = new URLSearchParams(loc.search);
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch { /* ignore */ }
      if (tries < 8) setTimeout(poll, 2000); else setStatus("pending");
    };
    poll();
  }, [loc, cancelled]);

  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center">
      {status === "checking" && <p className="font-display text-3xl cc-navy">Vérification du paiement…</p>}
      {status === "paid" && (
        <div className="fade-up" data-testid="payment-success">
          <CheckCircle2 className="mx-auto text-green-500" size={72} />
          <h1 className="font-display text-4xl cc-navy mt-4">COMMANDE CONFIRMÉE !</h1>
          <p className="text-slate-600 mt-3">Votre pizzeria partenaire a reçu votre commande et prépare votre Cocarde. 📸 N'oubliez pas de vous filmer avec la boîte !</p>
          <div className="flex flex-wrap justify-center gap-3 mt-7">
            <Link to="/dashboard" className="btn-cocarde">Suivre ma commande</Link>
            <Link to="/concours" className="btn-navy">Je me présente aux élections</Link>
          </div>
        </div>
      )}
      {(status === "cancel" || status === "error") && (
        <div data-testid="payment-cancel">
          <XCircle className="mx-auto text-cc-red" size={72} />
          <h1 className="font-display text-4xl cc-navy mt-4">PAIEMENT ANNULÉ</h1>
          <p className="text-slate-600 mt-3">Aucun montant n'a été débité. Vous pouvez reprendre votre commande quand vous voulez.</p>
          <Link to="/commander" className="btn-cocarde inline-block mt-6">Reprendre ma commande</Link>
        </div>
      )}
      {status === "pending" && (
        <div>
          <h1 className="font-display text-3xl cc-navy">Paiement en cours de traitement</h1>
          <p className="text-slate-600 mt-3">Cela peut prendre quelques instants. Consultez votre espace client.</p>
          <Link to="/dashboard" className="btn-navy inline-block mt-6">Mon espace</Link>
        </div>
      )}
    </div>
  );
}
